import { HoverCard, HoverCardContent, HoverCardTrigger } from 'ui/hoverCard';
import { PreviewThumbnail } from 'modules/missionControl/lib/components/PreviewThumbnail';
import { PreviewCard } from 'modules/missionControl/lib/components/PreviewCard';
import { ResourceType } from '../../types';

export const RESOURCE_PREVIEW_TEST_IDS = {
  WRAPPER: 'resource-preview',
};

type ResourcePreviewProps = {
  thumbnailUrl?: string;
  isThumbnailLoading?: boolean;
  messageMedium?: string;
  templateId?: number;
  resourceUrl: string;
  resourceType: ResourceType;
};

/** Component for displaying a preview thumbnail and preview hover card for a resource (i.e. Template, Campaign, Journey, etc.)
 *  Links to a provided resourceUrl when clicked
 */
export const ResourcePreview = ({
  thumbnailUrl,
  isThumbnailLoading = false,
  messageMedium,
  templateId,
  resourceUrl,
  resourceType,
  ...rest
}: ResourcePreviewProps) => {
  return (
    <div data-test={RESOURCE_PREVIEW_TEST_IDS.WRAPPER} {...rest}>
      <HoverCard>
        <HoverCardTrigger asChild>
          <a href={resourceUrl} title={`View ${resourceType}`}>
            <PreviewThumbnail
              resourceType={resourceType}
              resource={{ messageMedium, templateId }}
              previewThumbnail={thumbnailUrl}
              isLoading={isThumbnailLoading}
            />
          </a>
        </HoverCardTrigger>
        <HoverCardContent>
          <PreviewCard resourceType={resourceType} resource={{ messageMedium, templateId }} />
        </HoverCardContent>
      </HoverCard>
    </div>
  );
};
